import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface CompletePhoneVerificationResponse extends BackendResponse {}

export interface CompletePhoneVerificationParameters extends NextApiParams {
  idVerify: number;
  otc: string;
}

export const completePhoneVerification = withNextApi<
  CompletePhoneVerificationResponse,
  CompletePhoneVerificationParameters
>("/cvp/CvpCompletePhoneVerification");
